var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-container"},[_c('div',{staticClass:"calendar-tips"},[_vm._v(_vm._s(_vm.tips))]),_c('CalendarWeek'),_c('CalendarBody',_vm._b({},'CalendarBody',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }